const fontFace = (name, src, fontWeight = 'normal', fontStyle = 'normal') => ({
  fontFamily: name,
  src: `url(${`https://media-cdn.getbento.com/fonts/circular/${src}.eot`}?#iefix) format('embedded-opentype'),
            url(${`https://media-cdn.getbento.com/fonts/circular/${src}.otf`}) format('opentype'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.woff`}) format('woff'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.woff2`}) format('woff2'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.ttf`}) format('truetype'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.svg`}#${name}) format('svg')`,
  fontStyle,
  fontWeight,
  fontDisplay: 'swap'
});

const fonts = {
  regular: 'Circular',
  italic: 'CircularItalic',
  bold: 'CircularBold',
  medium: 'CircularMed'
};

export const FONT_FACE_CIRCULAR = {
  regular: fontFace(fonts.regular, 'CircularStd-Book', 400),
  italic: fontFace(fonts.italic, 'CircularStd-BookItalic', 300, 'italic'),
  bold: fontFace(fonts.bold, 'CircularStd-Bold', 700),
  medium: fontFace(fonts.medium, 'CircularStd-Medium', 500)
};

export default fonts;
